import apiCDS from "./apiCDS";
import activeCampaignTags from "../constants/active-campaign-tags.json";

const sendRequest = (email, tagId) => {
  apiCDS.post("/activecampaign/tag", {
    email,
    tagId,
  });
};

export const ActiveCampaign = {
  onSuccessLogin(email) {
    sendRequest(email, activeCampaignTags.sucessologin);
  },
  onFailedLogin(email) {
    sendRequest(email, activeCampaignTags.falhalogin);
  },
  onSignupErrorUserExists(email) {
    sendRequest(email, activeCampaignTags.usuarioexistenteaniversario);
  },
};

export default ActiveCampaign;
